import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";
import { useLang } from "../i18n";

const FAMILIES = [
  { slug: "iphone", title: "iPhone reconditionné" },
  { slug: "samsung", title: "Samsung reconditionné" },
  { slug: "accessoires", title: "Accessoires" },
  { slug: "apple-watch", title: "Apple Watch reconditionnée" },
];

const POPULAR = [
  { l: "Moins de 300 €", to: "/reconditionne-moins-de-300-euros" },
  { l: "300 – 500 €", to: "/reconditionne-300-500-euros" },
  { l: "iPhone pas cher", to: "/iphone-pas-cher" },
  { l: "Samsung pas cher", to: "/samsung-pas-cher" },
  { l: "Trouver mon smartphone", to: "/trouver-mon-smartphone" },
  { l: "Tout le catalogue", to: "/catalogue" },
];

function SeoColumn({ slug, title }) {
  const { t } = useLang();
  const { data: products = [] } = useQuery({
    queryKey: ["seo-links", slug],
    queryFn: async () => (await api.get("/products", { params: { category: slug, limit: 12 } })).data,
    staleTime: 300000,
  });
  if (!products.length) return null;
  return (
    <div data-testid={`seo-col-${slug}`}>
      <div className="mb-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-ink-faint">{t(title)}</div>
      <ul className="flex flex-col gap-2">
        {products.slice(0, 8).map((p) => (
          <li key={p.slug}>
            <Link to={`/produit/${p.slug}`} className="text-[13px] leading-snug text-ink-soft transition-colors hover:text-ink" data-testid={`seo-link-${p.slug}`}>
              {p.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function SeoLinks() {
  const { t } = useLang();
  return (
    <section className="border-t border-black/5 pt-10" data-testid="footer-seo-links" aria-label="Navigation rapide">
      <div className="mb-6 text-xs font-semibold uppercase tracking-[0.16em] text-[#0073FF]">— {t("Nos modèles reconditionnés")}</div>
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {FAMILIES.map((f) => (
          <SeoColumn key={f.slug} slug={f.slug} title={f.title} />
        ))}
      </div>
      <div className="mt-8 flex flex-wrap items-center gap-x-3 gap-y-2" data-testid="footer-seo-popular">
        <span className="text-[11px] font-semibold uppercase tracking-[0.16em] text-ink-faint">{t("Recherches populaires")} :</span>
        {POPULAR.map((x) => (
          <Link key={x.l} to={x.to} className="rounded-full border border-black/10 bg-white/60 px-3 py-1.5 text-[12px] text-ink-soft backdrop-blur transition-colors hover:border-[#0073FF]/40 hover:text-ink" data-testid={`seo-pop-${x.l}`}>
            {t(x.l)}
          </Link>
        ))}
      </div>
    </section>
  );
}
